let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  // 学情看板详细数据 https://yapi.aixuexi.com/project/42/interface/api/196880
  kanbanList: `${baseUrl}/learn/kanban/list`,
  // 老师对学生备注-查询 https://yapi.aixuexi.com/project/42/interface/api/196889
  remarkList: `${baseUrl}/student/remark/query/list`,
  // 老师对学生备注-创建 https://yapi.aixuexi.com/project/42/interface/api/196883
  createRmark: `${baseUrl}/student/remark/create`,
  // 老师对学生备注-删除 https://yapi.aixuexi.com/project/42/interface/api/196886
  delRmark: `${baseUrl}/student/remark/delete`,
  // 老师对学生备注-查询 https://yapi.aixuexi.com/project/42/interface/api/196889
  queryRmark: `${baseUrl}/student/remark/query/list`
}
